import { createContext } from 'react';

import { Context } from '../../../types';
import { PaymentsTerminal } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<PaymentsTerminal>>(getContextDefaultValues(api));
